import Slider from './Slider';
export default Slider;



// WEBPACK FOOTER //
// ./src/js/Sliders/index.js